import { defaultChartSetting, defaultChartWidthTypes } from '../data/defaultChartSchema';
import { allChartTypes } from 'lib/reusable-components/reusableData/chartTypesSchema';

import { getTimeFrame } from './chartHelperFunctions';

interface props {
  stateProps: any;
  chartSchema: any;
  allTableData: any;
  populateState: boolean;
  setPopulateState: any;
}

export const chartPopulate = (props: props) => {
  const { stateProps, chartSchema, allTableData, populateState, setPopulateState } = props;

  if (!populateState) return;

  const CheckUpdateAndUpdateFunction = (setFunction: any, data: any, defaultData: any) => {
    if (data !== null && data !== undefined) {
      setFunction(data);
    } else {
      setFunction(defaultData);
    }
  };
  const {
    setPopulateCount,
    setAllTableData,
    setFilterdTableSchema,
    setChatName,
    setChartDescription,
    setchartType,
    setXAxisData,
    setYAxisData,
    setChartToolTip,
    setChartXAxisStyle,
    setChartYAxisStyle,
    setChartFilter,
    setChartWidth,
    setIsInsight,
    setIsForecast,
    setIsCrossReport,
    setIskeepAllFilters,
    setIsZoomBrush,
    setIsDateHierarchy,
    setPlotAreaBackground,
    setGridLines,
    setColumnDropNumber,
    defaultDateTimeCol,
    setTimeFrame,

    //Special Chart
    setChartHeaderImage,
    setChartCardType, //Card
    setGeoGroup, //GEO
    setBarStackLineTargetPoints, //BARSTACKLINE
    setKpiTargetPoints, //KPIMETER
    //PLOT
    setPlotGroup, //PLOT
    setPlotGroupStyle, //PLOT
    setPivotTableTitleStyle, //PIVOTTABLE

    //HEATMAP
    setHeatMapGroup, //HEATMAP
    setHeatMapColor, //HEATMAP
    //TREEMAP
    setTreeMapColor, //TREEMAP
    // COLOR
    setColorAxis, //COLOR
    // DOUBLEAXIS
    setDoubleAxis, //DOUBLEAXIS
    // RADIALLINE
    setRadialLineBackGroundColor, //RADIALLINE
  } = stateProps;

  const chartType = (chartKey: string) => {
    if (chartKey) {
      const [chartType] = allChartTypes.filter((e) => e.chartKey === chartKey);
      return chartType;
    } else {
      return undefined;
    }
  };

  const chartWidth = (chartWidthKey: string) => {
    if (chartWidthKey) {
      const [chartWidth] = defaultChartWidthTypes.filter((e) => e.key === chartWidthKey);
      return chartWidth;
    } else {
      return undefined;
    }
  };
  const getChartTimeFrame = (timeFrameAction?: any) => {
    if (timeFrameAction) {
      const finalTimeFrame = getTimeFrame({
        action: timeFrameAction,
        tableSchema: allTableData,
        defaultDateTimeCol,
      });
      return finalTimeFrame;
    }

    const chartTimeFrame = chartSchema?.timeFrame;
    if (chartTimeFrame?.[defaultDateTimeCol]) {
      const action = `${chartTimeFrame?.[defaultDateTimeCol]?.value?.xDay}`;
      const finalTimeFrame = getTimeFrame({
        action: action,
        tableSchema: allTableData,
        defaultDateTimeCol,
      });
      return finalTimeFrame;
    }
    const finalTimeFrame = getTimeFrame({
      action: 'null',
      tableSchema: allTableData,
      defaultDateTimeCol,
    });
    return finalTimeFrame;
  };
  interface getDefaultAxisStyleWithTitleProps {
    defaultStyle: any;
    axis: any;
  }
  const getDefaultAxisStyleWithTitle = ({
    defaultStyle,
    axis = [],
  }: getDefaultAxisStyleWithTitleProps) => {
    const labelArray = axis.map((elem: any) => {
      return elem?.label;
    });
    const label = labelArray.join(',');

    return { ...defaultStyle, label };
  };
  interface ColumnDropNumberProps {
    xAxis: any[];
    yAxis: any[];
    group: any[];
  }
  const getColumnDropNumber = (ColumnDropNumberProps: ColumnDropNumberProps) => {
    const { xAxis, yAxis, group } = ColumnDropNumberProps;
    let columnDropNumber = 0;
    columnDropNumber = columnDropNumber + xAxis.length;
    columnDropNumber = columnDropNumber + yAxis.length;
    columnDropNumber = columnDropNumber + group.length;
    return columnDropNumber;
  };
  const updateArray = [
    {
      setFunction: setAllTableData,
      data: allTableData,
      defaultData: [],
    },
    {
      setFunction: setFilterdTableSchema,
      data: allTableData,
      defaultData: [],
    },
    // set
    {
      setFunction: setChatName,
      data: chartSchema.name,
      defaultData: defaultChartSetting.name,
    },
    {
      setFunction: setChartDescription,
      data: chartSchema.desc,
      defaultData: defaultChartSetting.desc,
    },
    {
      setFunction: setchartType,
      data: chartType(chartSchema.chartType),
      defaultData: defaultChartSetting.chartType,
    },
    {
      setFunction: setXAxisData,
      data: chartSchema.xAxis,
      defaultData: defaultChartSetting.xAxis,
    },
    {
      setFunction: setYAxisData,
      data: chartSchema.yAxis,
      defaultData: defaultChartSetting.yAxis,
    },
    {
      setFunction: setChartToolTip,
      data: chartSchema.tooltip,
      defaultData: defaultChartSetting.tooltip,
    },
    {
      setFunction: setChartXAxisStyle,
      data: chartSchema.xAxisStyle,
      defaultData: getDefaultAxisStyleWithTitle({
        defaultStyle: defaultChartSetting.xAxisStyle,
        axis: chartSchema.xAxis,
      }),
    },
    {
      setFunction: setChartYAxisStyle,
      data: chartSchema.yAxisStyle,
      defaultData: getDefaultAxisStyleWithTitle({
        defaultStyle: defaultChartSetting.yAxisStyle,
        axis: chartSchema.yAxis,
      }),
    },
    {
      setFunction: setChartFilter,
      data: chartSchema.filters,
      defaultData: defaultChartSetting.filters,
    },
    {
      setFunction: setChartWidth,
      data: chartWidth(chartSchema.chartWidth),
      defaultData: defaultChartSetting.chartWidth,
    },
    {
      setFunction: setIsInsight,
      data: chartSchema.isInsight,
      defaultData: defaultChartSetting.isInsight,
    },
    {
      setFunction: setIsForecast,
      data: chartSchema.isForecast,
      defaultData: defaultChartSetting.isForecast,
    },
    {
      setFunction: setIsCrossReport,
      data: chartSchema.isCrossReport,
      defaultData: defaultChartSetting.isCrossReport,
    },
    {
      setFunction: setIskeepAllFilters,
      data: chartSchema.iskeepAllFilters,
      defaultData: defaultChartSetting.iskeepAllFilters,
    },
    {
      setFunction: setIsZoomBrush,
      data: chartSchema.isZoomBrush,
      defaultData: defaultChartSetting.isZoomBrush,
    },
    {
      setFunction: setIsDateHierarchy,
      data: chartSchema.isDateHierarchy,
      defaultData: defaultChartSetting.isDateHierarchy,
    },
    {
      setFunction: setPlotAreaBackground,
      data: chartSchema.plotAreaBackground,
      defaultData: defaultChartSetting.plotAreaBackgroundSolid,
    },
    {
      setFunction: setGridLines,
      data: chartSchema.gridLines,
      defaultData: defaultChartSetting.gridLines,
    },
    {
      setFunction: setColumnDropNumber,
      data: chartSchema?.chartBuilderHelper?.columnDropNumber,
      defaultData: getColumnDropNumber({
        xAxis: chartSchema?.xAxis ?? defaultChartSetting.xAxis,
        yAxis: chartSchema?.yAxis ?? defaultChartSetting.yAxis,
        group: chartSchema?.group ?? defaultChartSetting.geoGroup,
      }),
    },
    // {
    //   setFunction:setTimeFrame,
    //   data:getChartTimeFrame(),
    //   defaultData:getChartTimeFrame(defaultChartSetting.timeFrame),
    // },
    //Special Chart
    //Card
    {
      setFunction: setChartCardType,
      data: chartSchema.chartCardType,
      defaultData: defaultChartSetting.chartCardType,
    },
    {
      setFunction: setChartHeaderImage,
      data: chartSchema?.headerImage,
      defaultData: defaultChartSetting.chartHeaderImage,
    },
    //GEO
    {
      setFunction: setGeoGroup,
      data: chartSchema.group,
      defaultData: defaultChartSetting.geoGroup,
    },
    //BARSTACKLINE
    {
      setFunction: setBarStackLineTargetPoints,
      data: chartSchema.targetPoints,
      defaultData: defaultChartSetting.barStackLineTargetPoints,
    },

    //KPIMETER
    {
      setFunction: setKpiTargetPoints,
      data: chartSchema.targetPoints,
      defaultData: defaultChartSetting.targetPoints,
    },
    //PLOT
    {
      setFunction: setPlotGroup,
      data: chartSchema.plotGroup,
      defaultData: defaultChartSetting.plotGroup,
    },
    {
      setFunction: setPlotGroupStyle,
      data: chartSchema.plotGroupStyle,
      defaultData: defaultChartSetting.plotGroupStyle,
    },
    //PIVOTTABLE
    {
      setFunction: setPivotTableTitleStyle,
      data: chartSchema.pivotTableTitleStyle,
      defaultData: defaultChartSetting.pivotTableTitleStyle,
    },
    //HEATMAP
    {
      setFunction: setHeatMapGroup,
      data: chartSchema.magnitude,
      defaultData: defaultChartSetting.heatMapGroup,
    },
    //HEATMAP
    {
      setFunction: setHeatMapColor,
      data: chartSchema.heatMapColor,
      defaultData: defaultChartSetting.heatMapColor,
    },
    //TREEMAP
    {
      setFunction: setTreeMapColor,
      data: chartSchema.treeMapColor,
      defaultData: defaultChartSetting.treeMapColor,
    },
    //COLOR
    {
      setFunction: setColorAxis,
      data: chartSchema.colorAxis,
      defaultData: defaultChartSetting.colorAxis,
    },
    //DOUBLEAXIS
    {
      setFunction: setDoubleAxis,
      data: chartSchema.doubleAxis,
      defaultData: false,
    },
    //RADIALLINE
    {
      setFunction: setRadialLineBackGroundColor,
      data: chartSchema.radialLineBackGroundColor,
      defaultData: defaultChartSetting.radialLineBackGroundColor,
    },
  ];

  // populateState
  updateArray.forEach(({ setFunction, data, defaultData }) => {
    CheckUpdateAndUpdateFunction(setFunction, data, defaultData);
  });
  setPopulateCount((currentCount: number) => currentCount + 1);
  setPopulateState((preElem: boolean) => !preElem);
};
